import { createContext } from 'react'

export const tabVisibilityContext = createContext(true)
